import { RegistrationAffiliation, Session } from '@/api/dtos';
import { FACULTY_DINNER_SESSION_ID } from '@/constants/constants';

interface FacultyDinnerEligibilityContext {
    isCap: boolean;
    isTAndECSpeaker: boolean;
    registrationAffiliation?: RegistrationAffiliation | null;
}

const FACULTY_DINNER_EXCLUDED_AFFILIATIONS: readonly RegistrationAffiliation[] = [
    RegistrationAffiliation.Other,
    RegistrationAffiliation.EducationTravelGrant,
    RegistrationAffiliation.TraineeAndEarlyCareersDayGrant,
];

export const shouldExcludeFacultyDinner = (
    session: Pick<Session, 'id'>,
    {
        isCap,
        isTAndECSpeaker,
        registrationAffiliation,
    }: FacultyDinnerEligibilityContext,
): boolean => {
    if (session.id !== FACULTY_DINNER_SESSION_ID) {
        return false;
    }

    if (isCap) {
        return true;
    }

    if (
        registrationAffiliation === RegistrationAffiliation.GuestSpeaker &&
        isTAndECSpeaker
    ) {
        return true;
    }

    return (
        registrationAffiliation != null &&
        FACULTY_DINNER_EXCLUDED_AFFILIATIONS.includes(registrationAffiliation)
    );
};
